import { createContext, useState, useEffect, useRef } from 'react';
import helpers from '../utilities/helpers';
import allStaticFilterOptions from './filterOptions';
import{ useAuth } from '../AuthContext';
var _ = require('lodash');
let { deepEqual, getAuthToken } = helpers;

const RESTART_OBJECT = {
   current: 'default',
   filters: { default: null, buffer: null },
};
// the hand-written list of 53 places that used to live here is gone.
// It held the fifty states, DC and Puerto Rico, and it threw away every other
// place before the list was drawn — which is why the British, Canadian and
// Israeli grants already on the site could never appear, and why collecting
// more never changed anything. The list is now built from the grants
// themselves: the backend reports which places actually have grants, and a
// country appears the day its first grant is loaded.
const GEO_CATEGORY = 'Geographic Focus';
const UNITED_STATES = 'United States (all States)';
const INTERNATIONAL = 'International / worldwide';

// the separate State filter was a mistake and is gone; states live under the United States heading in Geographic Focus.
function buildPlaceOptions(places) {
   if (!places) return null;
   const geo = {};

   if (places.unitedStates) geo[UNITED_STATES] = true;
   // The states sit directly under the United States heading.
   Object.keys(places.states || {}).forEach(name => { geo[name] = true; });
   Object.keys(places.continents || {}).forEach(continent => {
      geo[continent] = true;
      Object.keys(places.continents[continent]).forEach(country => {
         geo[country] = true;
      });
   });
   if (places.international) geo[INTERNATIONAL] = true;

   return { [GEO_CATEGORY]: geo };
}

const VALID_FUNDING_SOURCE = [];

export const filterDataContext = createContext(null);

export default function FilterDataProvider({ children }) {
   const baseurl = process.env.REACT_APP_API_URL;
   let [inited, setInited] = useState(false);
   let [filterData, setFilterData] = useState(RESTART_OBJECT);
   let [overideWithState, setOverideWithState] = useState(false);
   let [overideTimes, setOverideTimes] = useState(3);
   let [extendMenu, setExtendMenu] = useState(false);
   let [extendedName, setExtendedName] = useState('Save as');
   let previousFilterData = usePrevious(filterData);
   let [allFiltersOptions, setAllFiltersOptions] = useState(
      sortAvalibleFiltersToDisplayFromSpesification(allStaticFilterOptions)
   );
   const setHasChangedFilter = () => {};
   const { idToken } = useAuth();
   /* useEffect(() => {
      deleteFilters();
   }, []); */

   // Geographic options arrive with the first normal grant-list response.
   // This preserves the same options without a second startup request.
   function setAvailablePlaces(places) {
      const built = buildPlaceOptions(places);
      if (!built) return;
      setAllFiltersOptions(previous => ({ ...previous, ...built }));
   }

   // 1) Load from server as soon as idToken is ready (and only once)
   useEffect(() => {
   if (!idToken || inited) return;

   fetch(`${baseurl}/api/getuserfiltersettings`, {
      method: 'post',
      headers: {
         'Content-Type': 'application/json',
         'Authorization': `Bearer ${idToken}`,
      },
   })
      .then(res => res.json())
      .then(res => {
         if (res && res.filterData) {
         setFilterData(res.filterData);
         } else {
         console.log('failed to load filter');
         setFilterData(RESTART_OBJECT);
         }
         setInited(true);
      })
      .catch(err => {
         console.error('getuserfiltersettings failed', err);
         setFilterData(RESTART_OBJECT);
         setInited(true);
      });
   }, [idToken, inited]);   // <-- note idToken in deps

   // 2) Persist to localStorage whenever filterData changes AFTER init
   useEffect(() => {
   if (!inited) return;
   try {
      window?.localStorage?.setItem('savedFilter', JSON.stringify(filterData));
   } catch (e) {
      console.log('localStorage write failed', e);
   }
   }, [inited, filterData]);

   return (
      <filterDataContext.Provider
         value={{
            inited: inited,
            filterData: filterData,
            setFilterData: setFilterData,
            setAvailablePlaces: setAvailablePlaces,
            deleteFilters: deleteFilters,
            getCurrentFilterByCategory: getCurrentFilterByCategory,
            setCurrentFillter: setCurrentFillter,
            setFilterOfName: setFilterOfName,
            extendMenu: extendMenu,
            setExtendMenu: setExtendMenu,
            extendedName: extendedName,
            setExtendedName: setExtendedName,
            overideWithState: overideWithState,
            setOverideWithState: setOverideWithState,
            setCurrentFilterOfCategory: setCurrentFilterOfCategory,
            getNamesOfActiveFiltersOfCategory:
               getNamesOfActiveFiltersOfCategory,
            createNewFilterSave: createNewFilterSave,
            setCurrentFilter: setCurrentFilter,
            getListOfAvalibleFilters: getListOfAvalibleFilters,
            getCurrentFilterName: getCurrentFilterName,
            hasCurrentChanged: hasCurrentChanged,
            shouldOverideWithState: shouldOverideWithState,
            beginOveridingCategories: beginOveridingCategories,
            allFilterCategoryArray:
               createArrayOfAllFilterCategories(allFiltersOptions),
            allFiltersOptions: allFiltersOptions,
            setFilterItemStatusFromNameAndCategory:
               setFilterItemStatusFromNameAndCategory,
            isFilterItemOfNameAndCategoryIsActive:
               isFilterItemOfNameAndCategoryIsActive,
            getActiveFilters: getActiveFilters,
            useGetFormatedFiltersFromFilterData:
               useGetFormatedFiltersFromFilterData,
            clearCurrentSelections: clearCurrentSelections,
         }}
      >
         {children}
      </filterDataContext.Provider>
   );

   function deleteFilters() {
      
      fetch(`${baseurl}/api/saveuserfiltersettings`, {
         method: 'post',
          headers: { "Content-Type": "application/json" ,
                  "Authorization": `Bearer ${idToken}`,  // <-- send token here
        },
         body: JSON.stringify({
           
            filter: RESTART_OBJECT,
         }),
      })
         .then(res => res.json())
         .then(res => {})
         .catch(err => {
            console.log(err);
         });
      setFilterData(RESTART_OBJECT);
   }

   function getCurrentFilterByCategory(category) {
      if (
         filterData &&
         filterData.current &&
         filterData.filters &&
         filterData.filters['buffer'] &&
         filterData.filters['buffer'][category]
      ) {
         return filterData.filters['buffer'][category];
      }
      return null;
   }

   function setCurrentFillter(name) {
      let filterBuffer = { ...filterData };
      filterBuffer.current = name;
      filterBuffer.filters.buffer = filterBuffer.filters[name];
      setFilterData(filterBuffer);
   }

   function setFilterOfName(name, newFilter) {
      let filterBuffer = { ...filterData };
      filterBuffer.filters[name] = newFilter;
      setFilterData(filterBuffer);
   }

   function setCurrentFilterOfCategory(category, filter) {
      let filterBuffer = JSON.parse(JSON.stringify(filterData));
      if (!filterBuffer.filters[`buffer`]) filterBuffer.filters[`buffer`] = {};
      filterBuffer.filters[`buffer`][category] = filter;

      saflySetFilterData(filterBuffer);
   }

   function getNamesOfActiveFiltersOfCategory(category) {
      if (
         !filterData ||
         !filterData.filters ||
         !filterData.filters.buffer ||
         !filterData.filters.buffer[category]
      ) {
         return null;
      }
      let refined = filterData.filters.buffer[category]
         .filter(item => {
            return item.isRefined;
         })
         .map(item => {
            return item.label;
         });
      if (refined.length <= 0) {
         return null;
      } else return refined;
   }

   // function createNewFilterSave(name, filter) {
   //    let filterBuffer = JSON.parse(JSON.stringify(filterData));
   //    filterBuffer.filters[name] = filter.filters['buffer'];
   //    filterBuffer.current = name;
   //    saflySetFilterData(filterBuffer);
   //    let authToken = getAuthToken().authToken;
   //    if (!authToken || authToken.retrieveAuthTokenFailed) {
   //       console.log('Failed to retreave auth token from storage');
   //       return;
   //    }

   //    fetch(`${baseurl}/api/saveuserfiltersettings`, {
   //       method: 'post',
   //       headers: { "Content-Type": "application/json" ,
   //                "Authorization": `Bearer ${idToken}`,  // <-- send token here
   //      },
   //       body: JSON.stringify({
            
   //          filter: filterBuffer,
   //       }),
   //    })
   //       .then(res => res.json())
   //       .then(res => {})
   //       .catch(err => {
   //          console.log(err);
   //       });
   // }

   function createNewFilterSave(name) {
      const clean = (name || "").trim();
      if (!clean) return;
    
      // Start from current state
      const next = JSON.parse(JSON.stringify(filterData || RESTART_OBJECT));
    
      // Ensure containers exist
      if (!next.filters) next.filters = { default: null, buffer: {} };
    
      // 🔑 Snapshot the CURRENT UI buffer (what the checkboxes updated)
      const currentBuffer = filterData?.filters?.buffer || {};
      next.filters[clean] = JSON.parse(JSON.stringify(currentBuffer));
      next.current = clean;
    
      // Update local state immediately so the new name appears in the list
      saflySetFilterData(next);
    
      // Persist to backend
      fetch(`${baseurl}/api/saveuserfiltersettings`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${idToken}`,
        },
        body: JSON.stringify({ filter: next }),
      })
        .then(res => res.json())
        .catch(err => console.log(err));
    }
    

   function setCurrentFilter(name) {
      let filterBuffer = JSON.parse(JSON.stringify(filterData));
      filterBuffer.filters.buffer = filterBuffer.filters[name];
      filterBuffer.current = name;

      saflySetFilterData(filterBuffer);
      setHasChangedFilter(true);

      let authToken =  getAuthToken().authToken;
      if (!authToken || authToken.retrieveAuthTokenFailed) {
         console.log('Failed to retreave auth token from storage');
         return;
      }

      fetch(`${baseurl}/api/saveuserfiltersettings`, {
         method: 'post',
          headers: { "Content-Type": "application/json" ,
                  "Authorization": `Bearer ${idToken}`,  // <-- send token here
        },
         body: JSON.stringify({
            authToken: authToken.authToken,
            filter: filterBuffer,
         }),
      })
         .then(res => res.json())
         .then(res => {})
         .catch(err => {
            console.log(err);
         });
   }

   function saflySetFilterData(filterBuffer) {
      if (!deepEqual(filterBuffer, filterData)) {
         setFilterData(filterBuffer);
      }
   }

   // "Clear All" button. Unticks every box in the current selection
   function clearCurrentSelections() {
      let filterBuffer = JSON.parse(JSON.stringify(filterData || RESTART_OBJECT));
      if (!filterBuffer.filters) filterBuffer.filters = { default: null };
      filterBuffer.filters.buffer = {};
      saflySetFilterData(filterBuffer);
   }

   function getListOfAvalibleFilters() {
      let filterArray = [];

      for (let key in filterData.filters) {
         if (key) filterArray.push(key);
      }

      return filterArray;
   }

   function getCurrentFilterName() {
      return filterData.current;
   }

   function beginOveridingCategories() {
      setOverideTimes(0);
   }
   function shouldOverideWithState() {
      if (overideTimes >= 3) {
         return false;
      } else {
         setOverideTimes(overideTimes + 1);
         return true;
      }
   }

   function hasCurrentChanged() {
      if (!previousFilterData) return false;
      return filterData.current !== previousFilterData.current;
   }

   function usePrevious(value) {
      // The ref object is a generic container whose current property is mutable ...
      // ... and can hold any value, similar to an instance property on a class
      const ref = useRef();
      // Store current value in ref
      useEffect(() => {
         ref.current = value;
      }, [value]); // Only re-run if value changes
      // Return previous value (happens before update in useEffect above)
      return ref.current;
   }

   function formatFacitRawObj(rawF) {}

   function createArrayOfAllFilterCategories(allFiltersOptions) {
      let filterArray = [];

      for (let category in allFiltersOptions) {
         filterArray.push(category);
      }

      return filterArray;
   }

   function setFilterItemStatusFromNameAndCategory(name, category) {
      if (!filterData) return null;
      let filterBuffer = JSON.parse(JSON.stringify(filterData));
      let currentName = 'buffer';

      if (
         !filterBuffer.filters ||
         !filterBuffer.filters[currentName] ||
         !filterBuffer.filters[currentName] ||
         !filterBuffer.filters[currentName][category]
      ) {
         if (!filterBuffer.filters) filterBuffer.filters = { default: null };
         if (!filterBuffer.filters[currentName])
            filterBuffer.filters[currentName] = {};
         if (!filterBuffer.filters[currentName][category])
            filterBuffer.filters[currentName][category] = {};
      }

      if (!filterBuffer.filters[currentName][category][name])
         filterBuffer.filters[currentName][category][name] = {
            isActive: false,
         };
      filterBuffer.filters[currentName][category][name].isActive =
         !filterBuffer.filters[currentName][category][name].isActive;

      setHasChangedFilter(true);
      setFilterData(filterBuffer);
   }

   function isFilterItemOfNameAndCategoryIsActive(name, category) {
      if (!filterData) return null;
      let filterBuffer = JSON.parse(JSON.stringify(filterData));
      let currentName = 'buffer';
      if (
         filterBuffer.filters &&
         filterBuffer.filters[currentName] &&
         filterBuffer.filters[currentName] &&
         filterBuffer.filters[currentName][category] &&
         filterBuffer.filters[currentName][category][name] &&
         filterBuffer.filters[currentName][category][name].isActive
      )
         return true;

      return false;
   }

   function getActiveFilters(filterData) {
      let activeFilters = [];

      if (!filterData) return activeFilters;
      let filterBuffer = JSON.parse(JSON.stringify(filterData));
      let currentName = 'buffer';

      if (
         !filterBuffer.filters ||
         !filterBuffer.filters[currentName] ||
         !filterBuffer.filters[currentName]
      ) {
         return activeFilters;
      }

      for (let filterCategory in filterBuffer.filters[currentName]) {
         if (!filterBuffer.filters[currentName][filterCategory]) continue;
         for (let filterName in filterBuffer.filters[currentName][
            filterCategory
         ]) {
            if (
               !filterBuffer.filters[currentName][filterCategory][filterName]
            ) {
               continue;
            }
            if (
               filterBuffer.filters[currentName][filterCategory][filterName]
                  .isActive
            ) {
               activeFilters.push({
                  category: filterCategory,
                  value: filterName,
               });
            }
         }
      }

      return activeFilters;
   }

   function useGetFormatedFiltersFromFilterData(filterData) {
      if (!filterData) return '';
      let filterBuffer = JSON.parse(JSON.stringify(filterData));
      let activeFilters = getActiveFilters(filterBuffer);
      if (!activeFilters) return '';

      let formatedFilter = [];

      activeFilters.forEach((activeFilter, i) => {
         formatedFilter.push(`${activeFilter.category}:${activeFilter.value}`);

         /* formatedFilter += `${activeFilter.category}:${activeFilter.value}${
            activeFilters.length - i !== 1 ? ' AND ' : ''
         }`; */
      });

      return formatedFilter;
   }

   function sortAvalibleFiltersToDisplayFromSpesification(allFiltersOptions) {
      if (!allFiltersOptions) return null;

      let filterBuffer = JSON.parse(JSON.stringify(allFiltersOptions));

      if (!filterBuffer) return null;

      return filterBuffer;
   }

   function filterFilter(filter, validItems) {
      let filterdFilterObj = {};
      for (let filterProp in filter) {
         let formatedFilterProp = formatFilterItem(filterProp);

         for (let i = 0; i < validItems.length; i++) {
            let formatedValid = formatFilterItem(validItems[i]);

            if (formatedFilterProp === formatedValid) {
               /* filterdFilterObj[formatedValid] = filter[filterProp]; */
               filterdFilterObj[filterProp] = filter[filterProp];
            } else if (formatedFilterProp.substring(1) === formatedValid) {
               /* filterdFilterObj[formatedValid] = filter[filterProp]; */
               filterdFilterObj[filterProp] = filter[filterProp];
            }
         }
      }

      return filterdFilterObj;
   }

   function formatFilterItem(item) {
      let formatedItem = item;
      while (formatedItem.indexOf(' ') > -1) {
         formatedItem = formatedItem.replace(' ', '');
      }
      while (formatedItem.indexOf('&nbsp;') > -1) {
         formatedItem = formatedItem.replace('&nbsp;', '');
      }
      formatedItem = formatedItem.toLowerCase();
      return formatedItem;
   }
}
